import { FaStar } from 'react-icons/fa';

const Rating = ({ checked }) => {
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="flex">
      {stars.map((star, index) => {
        return (
          <div className="text-lg md:text-3xl key={index}" key={index}>
            <FaStar
              className={
                checked > index
                  ? 'text-[#FFE081] hover:text-[#FFE081] '
                  : 'text-[#DEE2E6]'
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default Rating;
